export default {
  navigation: {
    next: "下一步",
    back: "上一步",
    surveyNavigation: "问卷导航",
    workspace: {
      home: "主页",
      example: "示例"
    }
  }
}
